import { produce } from 'immer'

import { Offer, OffersAndMetadata } from '@wwt/entities/search-response'

export const replaceOfferInPages = (
	pages: OffersAndMetadata[],
	offerId: Offer['IDs']['nonPersistingOfferId'],
	newOffer: Offer
): OffersAndMetadata[] => {
	return produce(pages, draftPages => {
		for (const page of draftPages) {
			const offerIndex = page.offers.findIndex(
				offer => offer.IDs.nonPersistingOfferId === offerId
			)

			if (offerIndex === -1) continue

			page.offers[offerIndex] = newOffer
			break
		}
	})
}
